var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.5625C11.1396 9.5625 13.2812 7.4209 13.2812 4.78125C13.2812 2.1416 11.1396 0 8.5 0C5.86035 0 3.71875 2.1416 3.71875 4.78125C3.71875 7.4209 5.86035 9.5625 8.5 9.5625ZM12.75 10.625H10.9205C10.1834 10.9637 9.36328 11.1562 8.5 11.1562C7.63672 11.1562 6.81992 10.9637 6.07949 10.625H4.25C1.90254 10.625 0 12.5275 0 14.875V15.4062C0 16.2861 0.713867 17 1.59375 17H15.4062C16.2861 17 17 16.2861 17 15.4062V14.875C17 12.5275 15.0975 10.625 12.75 10.625Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/user1.24bdca7e22c624fcc85962892e7155a3.svg";
export { ForwardRef as ReactComponent };